import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { prettyDate } from '../../../lib/time.js';
import Loader from '../../../components/Loader.js';
import { SelectInputField } from '../../../components/input';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:hover': {
      backgroundColor: theme.palette.common.highlightBlue,
    },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    padding: '0',
  },
  title: {
    marginBottom: '1rem',
  },
  controls: {
    padding: '1rem 0',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '1rem',
  },
  link: {
    display: 'block',
    textDecoration: 'none',
    color: theme.palette.text.secondary,
  },
  usernameCell: {
    wordBreak: 'break-all',  // prevent long usernames from blowing out table width.
    minWidth: '12rem',  // limit how far column can shrink.
  },
}));

const ReviewList = ({data=null, status, statusOptions, setStatus, setItemStatus}) => {
  const classes = useStyles();
  const itemUrl = (data) => `/${data.item_type}/${data.item_slug}`;
  const selectColor = (value) => {
    if (value === 'active') {
      return 'lightGreen';
    } else if (value === 'pending') {
      return 'orange';
    } else if (value === 'profance') {
      return 'red';
    } else {
      return 'lightBlue';
    }
  };

  if (data === null) {
    return (<Loader />);
  }

  return (
    <div className={classes.root}>
      <div className={classes.controls}>
        <SelectInputField
          label="Filter by Review Status"
          value={status}
          options={statusOptions}
          onChange={e => setStatus(e.target.value)}
        />
      </div>
      <TableContainer>
        <Table className={classes.table} aria-label="Reviews table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Created</StyledTableCell>
              <StyledTableCell>Author</StyledTableCell>
              <StyledTableCell>Rating</StyledTableCell>
              <StyledTableCell>Item</StyledTableCell>
              <StyledTableCell>Content</StyledTableCell>
              <StyledTableCell>Status</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(row => {
              const reviewType = (row.item_type === 'provider') ? 'Provider Review' : 'Listing Review';

              return (
                <StyledTableRow key={row.uuid}>
                  <StyledTableCell>{prettyDate(row.created_at)}</StyledTableCell>
                  <StyledTableCell className={classes.usernameCell}>
                    {row.author_username}
                    <br/>
                    {row.author_email}
                  </StyledTableCell>
                  <StyledTableCell>{row.rating}</StyledTableCell>
                  <StyledTableCell>
                    {row.item_name &&
                      <Link className={classes.link} to={itemUrl(row)}>{row.item_name}</Link>
                    }
                    {reviewType}
                  </StyledTableCell>
                  <StyledTableCell>{row.content}</StyledTableCell>
                  <StyledTableCell>
                    <Select
                      value={row.status}
                      variant="outlined"
                      style={{backgroundColor:selectColor(row.status)}}
                      onChange={e => setItemStatus(row.uuid, e.target.value)}
                    >
                      {statusOptions.map(item => (<MenuItem key={item} value={item}>{item}</MenuItem>))}
                    </Select>
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

ReviewList.propTypes = {
  data: PropTypes.array,
  status: PropTypes.string.isRequired,
  statusOptions: PropTypes.array.isRequired,
  setStatus: PropTypes.func.isRequired,
  setItemStatus: PropTypes.func.isRequired,
};

export default ReviewList;
